import React, { useState, FC, Fragment } from 'react';

import { Box, Container, Typography } from '@material-ui/core';
import cx from 'classnames';

import { ForEnterprise } from '../../types';
import { LazyLoadImage } from '../LazyloadImage';
import { Button } from '../UI/Button';
import useStyles from './styles';

interface ImageWithTabsBlockProps {
  data: ForEnterprise;
}

const ImageWithTabsBlock: FC<ImageWithTabsBlockProps> = ({ data }) => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const background = data?.background;
  const classes = useStyles(background)();

  return (
    <Box
      className={cx(
        classes.wrapper,
        'image-with-tabs-block',
        background === 'Dark' ? 'dark-block' : 'light-block',
      )}
    >
      <Container>
        <Box className={classes.contentWrap}>
          <Box className={classes.content}>
            <Typography
              data-testid="imageWithTabsHeading"
              variant="h2"
              component="h2"
              className={classes.heading}
            >
              {data?.heading}
            </Typography>
            <Typography data-testid="imageWithTabsDescription" className={classes.description}>
              {data?.description}
            </Typography>
            <Typography
              data-testid="imageWithTabsSubtitle"
              variant="h3"
              component="h3"
              className={classes.subheading}
            >
              {data?.sub_title}
            </Typography>
            <ul className={classes.tabs}>
              {data?.content?.map((item, i) => (
                <li
                  data-testid="imageWithTabsItemBtn"
                  key={item?.title}
                  onClick={() => setActiveTab(i)}
                  className={cx(
                    classes.tab,
                    activeTab === i && 'active-tab',
                    `image-with-tabs-block__tab-${i}`,
                  )}
                >
                  {item?.title}
                </li>
              ))}
            </ul>
            {data?.button_text && data?.button_url && (
              <Button
                data-testid="imageWithTabsBtn"
                className={cx(classes.button, 'button-desktop')}
                text={data?.button_text}
                link={data?.button_url}
              />
            )}
          </Box>
          <Box className={classes.imageList}>
            {data?.content?.map((item, i) => (
              <Fragment key={item?.desktopImageUrl}>
                <Box
                  data-testid="imageWithTabsItemMob"
                  className={cx(
                    classes.mobileImage,
                    activeTab === i && 'active-img',
                    `image-with-tabs-block__modile-img-${i}`,
                  )}
                >
                  {item?.mobileImageUrl && (
                    <LazyLoadImage
                      data-testid="imageWithTabsItemImageMob"
                      path={item.mobileImageUrl}
                      draggable={false}
                      alt={item?.title}
                      srcset={[{ height: 540 }]}
                    />
                  )}
                </Box>
                <Box
                  data-testid="imageWithTabsItem"
                  className={cx(
                    classes.desktopImage,
                    activeTab === i && 'active-img',
                    `image-with-tabs-block__desktop-img-${i}`,
                  )}
                >
                  {item?.desktopImageUrl && (
                    <LazyLoadImage
                      data-testid="imageWithTabsItemImage"
                      path={item?.desktopImageUrl}
                      draggable={false}
                      alt={item?.title}
                      srcset={[{ width: 850 }]}
                    />
                  )}
                </Box>
              </Fragment>
            ))}
          </Box>
          {data?.button_text && data?.button_url && (
            <Button
              data-testid="imageWithTabsBtnMob"
              className={cx(classes.button, 'button-mobile')}
              text={data?.button_text}
              link={data?.button_url}
            />
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default ImageWithTabsBlock;
